import { Component, OnInit } from '@angular/core'
import { environment } from 'environments/environment'

@Component({
  standalone: false,
  selector: 'app-map-attribute',
  templateUrl: './map-attribute.component.html',
  styleUrls: ['./map-attribute.component.scss'],
})
export class MapAttributeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  get politisLogos() {
    return environment.politis
  }
}
